/**
 * `Selection` module is used to handle RTE Selections.
 */
export * from './selection';
